/**
 * @generated SignedSource<<9c10bb9ce2402fc66f9b0131a2d0b16d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatThreadMessages_Recipient$data = {
  readonly firstName?: string | null | undefined;
  readonly isProfileFeedback?: boolean | null | undefined;
  readonly name?: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ChatThreadItem_Contact">;
  readonly " $fragmentType": "ChatThreadMessages_Recipient";
};
export type ChatThreadMessages_Recipient$key = {
  readonly " $data"?: ChatThreadMessages_Recipient$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatThreadMessages_Recipient">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatThreadMessages_Recipient",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isProfileFeedback",
          "storageKey": null
        }
      ],
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "type": "ChatBot",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChatThreadItem_Contact"
    }
  ],
  "type": "Recipient",
  "abstractKey": "__isRecipient"
};

(node as any).hash = "ba7075a6babcd188dc5252b5adc19d4c";

export default node;
